import { EventTimeline } from "../Notation/EventTimeline.js";
import { v4 as uuid } from "uuid";
export class BaseTrack {
    constructor(metadata, context, scheduleEvent, audioSource, connectionManager, settings) {
        this._startTime = 0;
        this._playing = false;
        this._timeline = new EventTimeline();
        this._context = context;
        this._metadata = metadata;
        this._scheduleEvent = scheduleEvent;
        this._connectionManager = connectionManager;
        this._scheduleEventFunc = function (quarterNotePosition) { this.scheduleSongEvents(quarterNotePosition); }.bind(this);
        this._scheduleEvent.addListener(this._scheduleEventFunc);
        this.audioSource = audioSource;
        if (settings != undefined) {
            this.id = settings.id;
            this._timeline.deserialise(settings.events, this._metadata);
            this._connectionManager.createConnections(this.audioSource, settings.connections);
        }
        else {
            this.id = uuid();
            this._connectionManager.createConnections(this.audioSource, ["Context"]);
        }
    }
    get timeline() {
        return this._timeline;
    }
    get connection() {
        return this._connectionManager.getConnections(this.audioSource)[0];
    }
    get possibleConnections() {
        return this._connectionManager.possibleConnectionStrings;
    }
    start(startPosition) {
        this.stop();
        if (startPosition == 0) {
            this._startTime = this._context.currentTime;
        }
        else {
            this._startTime = this._context.currentTime - this._metadata.positionQuarterNoteToSeconds(startPosition);
        }
        this._playing = true;
        this._timeline.start(startPosition);
    }
    stop() {
        this.audioSource.stop();
        this._playing = false;
    }
    scheduleSongEvents(quarterNoteTime) {
        if (this._playing) {
            let events = this._timeline.getEventsUntilTime(quarterNoteTime);
            events.forEach(event => {
                this.songEventHandler(event);
            });
        }
    }
    scheduleAllEvents() {
        this._startTime = this._context.currentTime;
        for (let i = 0; i < this._timeline.events.length; i++) {
            this.songEventHandler(this._timeline.events[i]);
        }
    }
    connectTo(connectionString) {
        if (connectionString in this._connectionManager.possibleConnections) {
            this._connectionManager.removeAllConnections(this.audioSource);
            this._connectionManager.addConnection(this.audioSource, connectionString);
        }
    }
    serialise() {
        return {
            "id": this.id,
            "source": this.audioSource.serialise(),
            "events": this.timeline.serialise(),
            "connections": this._connectionManager.getConnections(this.audioSource),
        };
    }
    destroy() {
        this.stop();
        this.audioSource.destroy();
        this._scheduleEvent.removeListener(this._scheduleEventFunc);
        this.audioSource = null;
    }
}
//# sourceMappingURL=BaseTrack.js.map